import { SortPages } from '../../consts/Sorts'

const initValues = () => {
  return Object.values(SortPages).reduce((acc, val) => {
    acc[val] = []
    return acc
  }, {})
}

const state = {
  sortBy: initValues(),
  sortDesc: initValues()
}

const mutations = {
  SET_SORT_BY(state, payload) {
    state.sortBy[payload.page] = payload.value
  },
  SET_SORT_DESC(state, payload) {
    state.sortDesc[payload.page] = payload.value
  }
}

const actions = {
  setSortBy(context, payload) {
    context.commit('SET_SORT_BY', {page: payload.page, value: payload.value})
  },
  setSortDesc(context, payload) {
    context.commit('SET_SORT_DESC', {page: payload.page, value: payload.value})
  }
}

const getters = {
  getSort: state => page => ({sortBy: state.sortBy[page], sortDesc: state.sortDesc[page]})
}

export default {
  state,
  mutations,
  actions,
  getters
}
